import React, { Component } from 'react';
import './KPIRefreshOverlay.css';
// import classNames from 'classnames';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';


interface Props {
    message?:string
}
interface State{
}

export default class KPIRefreshOverlay extends Component<Props, State>{
    constructor(props:Props){
        super(props);

        // this.state={
        //     toggled: true
        // }
    }

    render() {
        return (
            <div className="kpi-refresh-overlay">
                <Spinner white/>
                {
                    this.props.message &&
                    <div className="kpi-refresh-overlay-message">{ this.props.message }</div>
                }
                { this.props.children }
            </div>
        )
    }

};
